import { INSTRUCTOR_REQUIRED_LESSON_TYPES } from '@classCreation/data/instructorRequiredLessonTypes';

export default function isInstructorRequiredLesson(academyTopic) {
  if (!academyTopic?.lessons) return null;

  return academyTopic.lessons.some((lesson) =>
    INSTRUCTOR_REQUIRED_LESSON_TYPES.includes(lesson.lesson_type)
  );
}
